<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button>
        </div>
        <div class="col-sm" v-html="data.misc.stepXOfY"></div>
        <div class="col-sm">
          <!-- <button type="button" class="btn btn-link btn-r"
            :disabled="!isCodeLengthValid" @click="$router.push('/enterssn')">&#8594;</button> -->
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <br /><br />
          <h4 class="text-primary" v-html="data.phoneNumber.smsHeader"></h4>
          <p v-html="data.phoneNumber.smsText"></p>
          <div class="input-wrapper">
            <PincodeInput
              v-model="phoneCode"
              :autofocus="true"
              :length="codeLength"
              placeholder=""
            />
          </div>
          <div class="clearfix"></div>
          <p v-html="data.phoneNumber.smsExplanation"></p>
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-lg btn-block"
            :disabled="!isCodeLengthValid" @click="codeEntered()" v-html="data.misc.nextBtn"></button>
          <div class="clearfix--min"></div>
          <alert v-show="alert" v-html="data.error.errorHeader"></alert>
          <p v-html="data.phoneNumber.smsDisclaimer"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import PincodeInput from 'vue-pincode-input'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'

export default {
  name: 'entercode',
  components: {
    Alert,
    PincodeInput
  },
  data () {
    return {
      data: null,
      alert: false,
      phoneCode: '',
      codeLength: 6,
      language: sessionStorage.getItem('language')
    }
  },
  computed: {
    isCodeLengthValid () {
      return this.phoneCode.length === this.codeLength
    }
  },
  methods: {
    enterKeyHandler (e) {
      if (e.key === 'Enter' && this.isCodeLengthValid) {
        this.codeEntered()
      }
    },
    codeEntered () {
      this.alert = false
      let loader = this.$loading.show()
      const phoneNumber = sessionStorage.getItem('phoneNumber')
      axios.postVerifyCheck(config.verifyPhoneCheckUri, phoneNumber, this.phoneCode).then((response) => {
        if (response.status === 200) {
          loader.hide()
          sessionStorage.setItem('verificationCode', this.phoneCode)
          this.$router.push('enterssn')
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
          loader.hide()
          this.alert = true
        }
      })
    },
    async verifyPhone () {
      this.alert = false
      const phoneNumber = sessionStorage.getItem('phoneNumber')
      axios.postVerifyStart(config.verifyPhoneStartUri, phoneNumber).then((response) => {
        if (response.status === 200) {}
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
          this.alert = true
        }
      })
    }
  },
  created () {
    window.addEventListener('keydown', this.enterKeyHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterKeyHandler)
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          phoneNumber(locale: ` + sessionStorage.getItem('language') + `) {
            smsDisclaimer
            smsExplanation
            smsHeader
            smsText
            smsPlaceholderInput
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
            stepXOfY
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorHeader
          }
        }
      `
    })
    if (sessionStorage.getItem('phoneNumberConfirmed') === 'true') {
      sessionStorage.removeItem('phoneNumberConfirmed')
      await this.verifyPhone()
    }
    if (this.data) {
      this.data.misc.stepXOfY = this.data.misc.stepXOfY
        .replace('x', '2')
        .replace('y', '3')
      this.data.phoneNumber.smsText = this.data.phoneNumber.smsText.replace(
        '{number}', sessionStorage.getItem('phoneNumber')
      )
    }
    setTimeout(() => { window.scrollTo(0, 0) })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 6vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
button:disabled {
  opacity: 0.3;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EnterCode.vue